// eslint-disable-next-line no-undef
import jQuery from "jquery";

const $ = jQuery;

$(document).ready(() => {
    // eslint-disable-next-line func-names
    $("#toggle-mobile-menu").click(function () {
        $(this).toggleClass("mobile-menu-show");
        $("body").toggleClass("mobile-menu-show");
        $(".mobile-menu").toggleClass("mobile-menu-show");
        $("#shopify-section-announcement-bar").toggleClass(
            "hide-while-mobile-menu-open",
        );
    });
    // eslint-disable-next-line func-names
    $(".mobile-menu-item-button").click(function () {
        const item = $(this).data("item");
        $(`.mobile-menu-subitem[data-item=${item}]`).toggleClass(
            "mobile-menu-show",
        );
    });
    // eslint-disable-next-line func-names
    $(".mobile-menu-item-button-child").click(function () {
        const item = $(this).data("item");
        const subItem = $(this).data("subitem");
        $(
            `.mobile-menu-subitem-child[data-item=${item}][data-subitem=${subItem}]`,
        ).toggleClass("mobile-menu-show");
    });
    // eslint-disable-next-line func-names
    $(".mobile-menu-item-button-grandchild").click(function () {
        const item = $(this).data("item");
        const subItem = $(this).data("subitem");
        const grandSubItem = $(this).data("grand-subitem");
        // adjust height of this element to cover whole height and hide overlapped parent menu
        const dynamicHeight = document.querySelector(
            ".mobile-menu-subitem-child.mobile-menu-show",
        ).scrollHeight;
        $(
            `.mobile-menu-subitem-grandchild[data-item=${item}][data-subitem=${subItem}][data-grand-subitem=${grandSubItem}]`,
        )
            .toggleClass("mobile-menu-show")
            .css({ "min-height": `${dynamicHeight}px` });
    });
});
$(window).on("load", () => {
    const navHeight = $(".header-grid").outerHeight();
    // eslint-disable-next-line func-names
    $(".mega-menu-dropdown").each(function () {
        $(this).css("top", navHeight - 1);
        $(this).css("opacity", "1");
    });
});

// Add fixed position to the header if enabled
if ($(".fixed-header").length > 0) {
    const mainHeader = document.getElementById("main-header");
    const announceBar = document.getElementById("announce-bar");
    $(document).scroll(() => {
        let scrollHeightTrigger = 0;
        if (announceBar) {
            scrollHeightTrigger = announceBar.offsetHeight;
        }
        if ($(window).scrollTop() > scrollHeightTrigger) {
            // eslint-disable-next-line max-len
            // get element height of .header-grid.fixed-header and add as top margin to body add smooth transition
            if (mainHeader)
                document.body.style.marginTop = `${mainHeader.offsetHeight}px`;
            $(".fixed-header").addClass("fixed-header-position");
        } else {
            document.body.style.marginTop = 0;
            $(".fixed-header").removeClass("fixed-header-position");
        }
    });
}

// eslint-disable-next-line max-len
// Update the mobile menu offset so that it appears in the correct place whether or not the announcement bar is active
function updateMobileMenuTopOffset(ignoreTopOffset = false) {
    const headerElement = document.querySelector("#main-header");
    const mobileMenuElement = document.querySelector(".mobile-menu");

    if (headerElement && mobileMenuElement) {
        const headerBoundingRect = headerElement.getBoundingClientRect();
        let newMobileMenuOffset = headerBoundingRect.height;
        if (!ignoreTopOffset) newMobileMenuOffset += headerBoundingRect.y;

        mobileMenuElement.style.top = `${newMobileMenuOffset}px`;
        mobileMenuElement.style.height = `calc(100vh - ${newMobileMenuOffset}px)`;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    updateMobileMenuTopOffset();
});
document.addEventListener("scroll", () => {
    updateMobileMenuTopOffset();
});

const announcementBarCloseButton = document.querySelector(
    "#announce-bar .bannerClose",
);
if (announcementBarCloseButton) {
    announcementBarCloseButton.addEventListener("click", () => {
        updateMobileMenuTopOffset(true);
    });
}
